import { createContext, useContext } from 'react';
import type { LatestApp } from '@/lib/appUpdate';

export type UpdateState =
  | { kind: 'idle' }
  | { kind: 'checking' }
  | { kind: 'upToDate' }
  /** Não deu para saber (sem rede, por exemplo). */
  | { kind: 'unknown' }
  | { kind: 'available'; latest: LatestApp }
  /** O Android ainda não liberou este app para instalar atualizações. */
  | { kind: 'needsPermission'; latest: LatestApp }
  | { kind: 'downloading'; latest: LatestApp; progress: number | null }
  /** O instalador do Android está aberto: falta a pessoa confirmar lá. */
  | { kind: 'installing'; latest: LatestApp }
  | { kind: 'error'; latest: LatestApp; message: string };

export interface AppUpdate {
  /** Falso no navegador: não há o que mostrar. */
  enabled: boolean;
  currentVersion: string;
  state: UpdateState;
  /** Pergunta ao site se há versão nova. `manual` abre o aviso mesmo que a pessoa já tenha dito "Depois". */
  check: (options?: { manual?: boolean }) => Promise<void>;
  /** Começa a atualizar (pede a permissão do Android, se faltar; baixa; abre o instalador). */
  start: () => void;
  /** Fecha o aviso ("Depois"); na próxima vez que o app abrir, ele pergunta de novo. */
  dismiss: () => void;
  openInBrowser: () => void;
  /** Abre a tela do Android em que a pessoa libera este app para instalar atualizações. */
  openInstallSettings: () => void;
}

export const AppUpdateContext = createContext<AppUpdate | null>(null);

export function useAppUpdate(): AppUpdate {
  const value = useContext(AppUpdateContext);
  if (!value) {
    throw new Error('useAppUpdate precisa estar dentro de <AppUpdateProvider>.');
  }

  return value;
}
